import React, { useContext, useMemo, useEffect, useState, useCallback } from 'react';
import Panel from '../../../components/shared/Panel';
import { Grid, Form, GridColumn, Popup, Checkbox } from 'semantic-ui-react';
import { CirclePicker } from 'react-color';
import CustomerDropDown from '../../../components/shared/CustomerDropDown';
import PaymentArrangementsDropDown from '../../../components/shared/PaymentArrangementsDropDown';
import LanguagesDropDown from '../../../components/shared/LanguagesDropDown';
import NationalitiesDropDown from '../../../components/shared/NationalitiesDropDown';
import MarketSegmentsDropDown from '../../../components/shared/MarketSegmentsDropDown';
import ReservationSourcesDropDown from '../../../components/shared/ReservationSourcesDropDown';
import ReservationCategoriesDropDown from '../../../components/shared/ReservationCategoriesDropDown';
import { GroupReservationContext, actions } from '../context';
import _ from 'lodash'
import MethodOfPayment from '../MethodOfPayment';
import { CreateReservationGroup, UpdateReservationGroup, GetReservationCategories, RerouteGroupReservations, UpsertGroupBlock, UpdateComments } from '../../../api/services/pms';
import { CreateGuest, UpdateGuest } from '../../../api/services/crm';
import { GetArrangementGroups } from '../../../api/services/finance';
import { UpdateReservationColor } from '../../../api/services/pms';
import { GetHotelParameters } from '../../../api/services/organization';
import { onError, onWarning, onSuccess } from '../../../components/shared/messages';
import { ColorPickerColors } from '../../../components/shared/constants';
import qs from 'querystringify';
import { useLoader } from '../../../components/shared/utils';
import { HtmlEditor } from '../../../components/shared/HtmlEditor';
import { useTextResources } from '../../../language';

const GeneralTab = () => {
    const loader = useLoader()
    const { state, dispatch } = useContext(GroupReservationContext);
    const [Categories, getCategories] = useState([]);
    const [errors, setErrors] = useState({});
    const [IsRerouteToMainReservation, SetIsRerouteToMainReservation] = useState(false);
    const [defaultGuestNationalityID, setDefaultGuestNationalityID] = useState()
    const [PaymentArrangments, SetPaymentArrangment] = useState([]);
    const text = useTextResources()

    const reservationGroup = state.ReservationGroup;
    const mainReservation = reservationGroup.ReservationGroupReservations.find(x=>x.IsPrimaryReservationInGroup);
    const reservation = mainReservation.Reservation;

    if (!reservation.Guest) {
        reservation.Guest = {};
    }

    const guest = reservation.Guest

    useEffect(() => {
        dispatch({ type: actions.registerTabSave, index: 1, callback: Save });
    }, [state.ReservationGroup, state.isDirty])

    useEffect(() => {
        dispatch({ type: actions.setDirty, payload: false });

        (async () => {
            const categories = GetReservationCategories({});
            const paymentArrangment = GetArrangementGroups({ IncludeTransactionCodeGroup: true, IncludeFolioOwnerType: true });
            let initData = await Promise.all([categories, paymentArrangment]);
            getCategories(initData[0]);
            SetPaymentArrangment(initData[1]);
            const hotelParams = await GetHotelParameters({ ID: reservation.HotelId })
            
            if (hotelParams && hotelParams.CurrentHotel[0] && hotelParams.CurrentHotel[0].HotelParameter.DefaultGuestNationalityID) {
                setDefaultGuestNationalityID(hotelParams.CurrentHotel[0].HotelParameter.DefaultGuestNationalityID)
            }
            
        })();

    }, [])

    useEffect(() => {
        // store intitial  IsRerouteToMainReservation 
        SetIsRerouteToMainReservation(state.ReservationGroup.IsRerouteToMainReservation);
    }, [state.ReservationGroup.Id])

    const onChangeReservationGroup = (e, { value, name }) => {
        reservationGroup[name] = value;
        if (name == 'Name' && value) {
            setErrors(prev => { return { ...prev, reservationGroupName: null } })

        }
        dispatch({ type: actions.update })
    }

    const onChangeRerouteCheckBox = (e, { value, name }) => {
        const fitReservations = _.filter(reservationGroup.ReservationGroupReservations, fit => { return fit.ParentReservationID; });
        if (!uniqPaymentArrangements(fitReservations, reservation) && value) {
            onWarning({ "error": { "ErrorMessage": window.optima.resourceManager.messages.ThePartyReservationCouldNotBeSavedDueToRerouting } });
            return;
        }

        reservationGroup[name] = value;
        dispatch({ type: actions.update })
    }
    const onChangeReservationField = useCallback((value, name) => {
        reservation[name] = value;
        if (name == 'MarketSegmentID' && value) {
            guest["MarketSegmentID"] = value;
            setErrors(prev => { return { ...prev, MarketSegmentID: null } })
        }
        if (name == 'ReservationSourceID' && value) {
            setErrors(prev => { return { ...prev, ReservationSourceID: null } })
        }

        if ((name == 'AgentID' || name == 'CompanyID') && value) {
            setErrors(prev => { return { ...prev, AgentIDCompanyID: null } })
        }
        if (name == 'PaymentArrangementID' && value) {
            setErrors(prev => { return { ...prev, PaymentArrangementID: null } })
        }
        dispatch({ type: actions.update })
    })

    const onChangeGuestField = (value, name) => {
        guest[name] = value;
        if (name == 'LastName' && value) {
            setErrors(prev => { return { ...prev, GuestLastName: null } })
        }
        if (name == 'FirstName' && value) {
            setErrors(prev => { return { ...prev, GuestFirstName: null } })

        }
        dispatch({ type: actions.update })
    }

    const onChangeReservationCategories = (value) => {
        reservation["ReservationInCategories"] = value;
        dispatch({ type: actions.update })
    }

    const onChangeNationalityField = useCallback((item) => {
        if (item) {
            guest["NationalityID"] = item.Id;
            guest["LanguageID"] = item.LanguageID;
            setErrors(prev => { return { ...prev, NationalityID: null } })
        }
        dispatch({ type: actions.update });
    }, [guest])

    const setCustomerDefaults = (item) => {
        if (item.DefaultReservationMarketSegmentID) {
            if (!guest["MarketSegmentID"]) {
                guest["MarketSegmentID"] = item.DefaultReservationMarketSegmentID;
            }
            if (!reservation.MarketSegmentID) {
                reservation.MarketSegmentID = item.DefaultReservationMarketSegmentID;
            }

        }
        if (item.DefaultReservationSourceID) {
            if (!reservation.ReservationSourceID) {
                reservation.ReservationSourceID = item.DefaultReservationSourceID;
            }
        }
        if (item.DefaultPaymentArrangementID) {
            if (!reservation.PaymentArrangementID) {
                reservation.PaymentArrangementID = item.DefaultPaymentArrangementID;
            }
        }


    }
    const onChangeAgentCompany = useCallback((item, name) => {
        if (name == "AgentID") {
            if (item) {
                reservation.AgentID = item.Id;
                setCustomerDefaults(item);
            }
            else {
                reservation.AgentID = null;
            }
        }
        if (name == "CompanyID") {
            if (item) {
                reservation.CompanyID = item.Id;
                setCustomerDefaults(item);
            }
            else {
                reservation.CompanyID = null;
            }
        }
        setErrors(prev => { return { ...prev, AgentIDCompanyID: null } });

        dispatch({ type: actions.update })
    }, [guest])


    // use for form fields validation
    const validate = (state) => {
        const reservationGroup = state.ReservationGroup;
        const mainReservation = reservationGroup.ReservationGroupReservations.find(x=>x.IsPrimaryReservationInGroup);
        const reservation = mainReservation.Reservation;
        const guest = reservation.Guest;
        setErrors({});

        let shouldSave = true

        if (!reservationGroup.Name) {
            setErrors(prev => { return { ...prev, reservationGroupName: "ReservationGroup Name is a required field!" } })
            shouldSave = false
        }

        if (!guest.NationalityID) {
            guest.NationalityID = defaultGuestNationalityID
        }
        if (!guest.LastName) {
            setErrors(prev => { return { ...prev, GuestLastName: "Guest Last Name is a required field!" } })
            shouldSave = false
        }

        if (!guest.FirstName) {
            setErrors(prev => { return { ...prev, GuestFirstName: "Guest First Name is a required field!" } })
            shouldSave = false
        }

        if (!reservation.MarketSegmentID) {
            setErrors(prev => { return { ...prev, MarketSegmentID: "Market Segment  is a required field!" } })
            shouldSave = false
        }
        if (!reservation.ReservationSourceID) {
            setErrors(prev => { return { ...prev, ReservationSourceID: "Reservation Source is a required field!" } })
            shouldSave = false
        }
        if (!reservation.AgentID && !reservation.CompanyID) {
            setErrors(prev => { return { ...prev, AgentIDCompanyID: "Agent or Company is a required field!" } })
            shouldSave = false
        }

        if (!reservation.PaymentArrangementID) {
            setErrors(prev => { return { ...prev, PaymentArrangementID: "Payment Arrangement is a required field!" } })
            shouldSave = false
        }
        return shouldSave;
    }
    const Save = async () => {
        if (!validate(state)) {
            return false;
        }
        if (state.isDirty) {
            loader(true);
            const reservationGroup = state.ReservationGroup;
            const mainReservation = reservationGroup.ReservationGroupReservations.find(x=>x.IsPrimaryReservationInGroup);
            const reservation = mainReservation.Reservation;            
            const reservations = reservationGroup.ReservationGroupReservations;
            const fitReservations = _.filter(reservations, fit => { return fit.ParentReservationID; });

            const ReservationGroupSpecficationCreate = { ...reservationGroup, ReservationGroupReservations: null };
            const ReservationGroupSpecficationUpdate = { ...reservationGroup, ReservationGroupReservations: null };

            const saveReservationGroup = !reservationGroup.Id ? CreateReservationGroup(ReservationGroupSpecficationCreate) : UpdateReservationGroup(ReservationGroupSpecficationUpdate);
            if (!reservation.Guest.NationalityID) {
                reservation.Guest.NationalityID = defaultGuestNationalityID
            }
            const GuestSpecification = { ...reservation.Guest };
            const saveGuest = !reservation.GuestId ? CreateGuest(GuestSpecification) : UpdateGuest(GuestSpecification);


            let saveReroutePromise = null;
            let upsertMainBlockPromise = null;
            if (reservationGroup.Id){
                if(fitReservations.length && IsRerouteToMainReservation != reservationGroup.IsRerouteToMainReservation){
                    const reservationRerouteSpecification = {
                        RerouteReservationId: reservationGroup.IsRerouteToMainReservation ? mainReservation.Reservation.Id : null,
                        FITids: fitReservations.map((fitReservation) => { return fitReservation.Reservation.Id }),
                        HotelId: reservation.HotelId
                    };
                    saveReroutePromise = RerouteGroupReservations(reservationRerouteSpecification);
                }

                upsertMainBlockPromise =  UpsertGroupBlock({
                    ...reservationGroup, ReservationGroupReservations: [{
                      ...mainReservation,
                      Reservation: reservation
                    }]
                });
            }

            try {
                /* eslint-disable require-atomic-updates */
                //no await, excecuted in background
                updateColors();
                updateComments();
                let data = await Promise.all([saveReservationGroup, saveGuest, saveReroutePromise, upsertMainBlockPromise])
                
                SetIsRerouteToMainReservation(state.ReservationGroup.IsRerouteToMainReservation);
                reservationGroup["Id"] = data[0].Id;
                reservationGroup["CreateDate"] = data[0].CreateDate;
                reservation["Guest"] = data[1];
                reservation["GuestId"] = data[1].Id;

                if(upsertMainBlockPromise != null){
                    let updatedMainReservation = data[3].ReservationGroupReservations.Reservation;
                    _.assign(reservation, { ...updatedMainReservation })
                }

                dispatch({ type: actions.update });
                dispatch({ type: actions.setDirty, payload: false });
                onSuccess();
                loader(false)
                let params = qs.parse(window.location.search);
                params.groupid = data[0].Id;
                window.history.replaceState(undefined, undefined, qs.stringify(params, true))
                return true
                /* eslint-enable require-atomic-updates */
            } catch (error) {
                error.status === 400 ? onWarning(error) : onError(error)
                loader(false)
                return false
            }
        }
        return true;
    }

    const updateColors = async () => {
        const reservations =
            state.ReservationGroup.ReservationGroupReservations
                .filter(r => (!r.Reservation.Color || r.Reservation.Color !== reservationGroup.Color) && r.Reservation.Id)
                .map(r => {
                    return {
                        Id: r.Reservation.Id,
                        HotelId: r.Reservation.HotelId,
                        Color: reservationGroup.Color
                    }
                });

        if (reservations && reservations.length > 0) {
            const promises = reservations.map(r => UpdateReservationColor(r));
            return Promise.all(promises);
        }
    };

    const updateComments= async () => {
        const reservations =
            state.ReservationGroup.ReservationGroupReservations
                .filter(r => (!r.Reservation.Comments || r.Reservation.Comments !== reservationGroup.Comments) && r.Reservation.Id)
                .map(r => {
                    return {
                        Id: r.Reservation.Id,
                        HotelId: r.Reservation.HotelId,
                        Comments: reservation.Comments
                    }
                });

        if (reservations && reservations.length > 0) {
            const promises = reservations.map(reservation => UpdateComments(reservation));
            return Promise.all(promises);
        }
    };

    const uniqPaymentArrangements = (fits, main) => {
        let payArrangementIds = _.map(fits, fit => fit.Reservation.PaymentArrangementID);
        payArrangementIds.push(main.PaymentArrangementID);
        return _.uniq(payArrangementIds).length <= 1;
    }
    const filterPaymentArrangement = useCallback((options) => {
        if (PaymentArrangments && PaymentArrangments.length) {

            const groupedArrangements = _.chain(PaymentArrangments).groupBy("PaymentArrangementID").map((v, i) => {

                return {
                    PaymentArrangementID: i,
                    FolioOwnerTypes: _.uniqBy(_.map(v, 'FolioOwnerType'), (f) => { return f.EntityTypeId; })
                }
            }).value();

            const guestValues = _.filter(groupedArrangements, item => {
                const onlyGuest = _.find(item.FolioOwnerTypes, itemFolio => itemFolio.EntityTypeId == 3);
                return onlyGuest && item.FolioOwnerTypes.length == 1
            })

            let agentValues = [];
            let companyValues = [];
            if (reservation.AgentID) {
                agentValues = _.filter(groupedArrangements, item => {
                    return _.find(item.FolioOwnerTypes, itemFolio => itemFolio.EntityTypeId == 20)
                })
            }

            if (reservation.CompanyID) {
                companyValues = _.filter(groupedArrangements, item => {
                    return _.find(item.FolioOwnerTypes, itemFolio => itemFolio.EntityTypeId == 21)
                })
            }
            const ids = [..._.map(agentValues, item => parseInt(item.PaymentArrangementID)), ..._.map(companyValues, item => parseInt(item.PaymentArrangementID)), ..._.map(guestValues, item => parseInt(item.PaymentArrangementID))];

            if (ids.indexOf(reservation.PaymentArrangementID) == -1) {
                reservation.PaymentArrangementID = null;
            }
            return _.filter(options, option => {
                if (reservation.AgentID || reservation.CompanyID) {
                    if (_.find(ids, (id) => { return id == option.value })) {
                        return option.item
                    }
                }
                else return false
            })
        }
    }, [PaymentArrangments, reservation.PaymentArrangementID, reservation.AgentID, reservation.CompanyID])

    const AgentsSpec = useMemo(() => { return { CustomerTypeId: 2, GetOnlyCustomerArray: true, IsActive: true } }, []);
    const CompanySpec = useMemo(() => { return { CustomerTypeId: 1, GetOnlyCustomerArray: true, IsActive: true } }, []);

    const CommentsEditor = useMemo(()=>{
        if (reservation?.Comments) {
            // eslint-disable-next-line react/display-name
            return ()=><HtmlEditor defaultValue={reservation.Comments} style={{ height: "10em" }} onChange={value=>onChangeReservationField(value,"Comments")}/>
        } else {
            // eslint-disable-next-line react/display-name
            return ()=><HtmlEditor style={{ height: "10em" }} onChange={value=>onChangeReservationField(value,"Comments")}/>
        }
    }, [reservation?.Id])

    return (
        <React.Fragment>
            <Grid columns="2" className="fitWidth">
                <Grid.Row>
                    <Grid.Column width="11">
                        <Grid columns="2">
                            <Grid.Row>
                                <Grid.Column>
                                    <Panel header= {text("Groupdetails")}>
                                        <Form>
                                            <Form.Group >
                                                <Form.Input required
                                                    error={errors.reservationGroupName}
                                                    width="7"
                                                    name='Name'
                                                    label={text('GroupName')}
                                                    placeholder={text('GroupName')}
                                                    value={reservationGroup.Name || ""}
                                                    onChange={onChangeReservationGroup} />

                                                <Popup
                                                    position="top right"
                                                    key="color"
                                                    on="click"
                                                    trigger={
                                                        <Form.Button width="2" label={text('Color')} size='big'
                                                            style={reservationGroup.Color ? { backgroundColor: reservationGroup.Color } : { backgroundColor: '' }} >
                                                        </Form.Button>
                                                    }
                                                    content={
                                                        <div style={{ padding: '1em' }}>
                                                            <CirclePicker triangle="hide" width="168px"
                                                                colors={ColorPickerColors}
                                                                color={reservationGroup.Color ? reservationGroup.Color : ''}
                                                                onChangeComplete={(color) =>
                                                                onChangeReservationGroup(null, { value: color.hex, name: 'Color' })} />
                                                        </div>
                                                    }
                                                    hoverable
                                                />
                                                <Form.Field width="7">
                                                    <label>{text('FolioReroute')}</label>
                                                    <Checkbox label={text("RerouteToMainReservation")} onChange={(e, { checked }) => onChangeRerouteCheckBox(null, { value: checked, name: 'IsRerouteToMainReservation' })} checked={reservationGroup.IsRerouteToMainReservation || false} />
                                                </Form.Field>
                                            </Form.Group>
                                        </Form>
                                    </Panel>
                                </Grid.Column>
                                <Grid.Column>

                                    <Panel header={text("GroupStatistics")}>
                                        <Form>
                                            <Form.Group widths="equal" >
                                                <Form.Field
                                                    required
                                                    error={errors.MarketSegmentID}
                                                    name="MarketSegmentID" 
                                                    value={reservation.MarketSegmentID} 
                                                    control={MarketSegmentsDropDown} 
                                                    label={text("MarketSegment")} 
                                                    spec={{ShowInActive:true}}
                                                    onChange={(value) => onChangeReservationField(value, "MarketSegmentID")} />
                                                <Form.Field
                                                    required
                                                    error={errors.ReservationSourceID}

                                                    name="ReservationSourceID" value={reservation.ReservationSourceID} control={ReservationSourcesDropDown} label={text("ReservationSource")} onChange={(value) => onChangeReservationField(value, "ReservationSourceID")} />
                                            </Form.Group>
                                        </Form>
                                    </Panel>

                                </Grid.Column>

                            </Grid.Row>


                            <Grid.Row>
                                <Grid.Column>
                                    <Panel header={text("Customer")}>
                                        <Form>
                                            <Form.Group widths="equal">
                                                <Form.Field
                                                    required
                                                    error={errors.AgentIDCompanyID}
                                                    name="AgentID" 
                                                    value={reservation.AgentID} 
                                                    control={CustomerDropDown} 
                                                    clearable 
                                                    spec={AgentsSpec} 
                                                    onChangeItem={(item) => onChangeAgentCompany(item, "AgentID")} 
                                                    label={text("Agent")}/>
                                                <Form.Field
                                                    required
                                                    error={errors.AgentIDCompanyID}
                                                    name="CompanyID" 
                                                    value={reservation.CompanyID} 
                                                    control={CustomerDropDown} 
                                                    clearable 
                                                    spec={CompanySpec} 
                                                    onChangeItem={(item) => onChangeAgentCompany(item, "CompanyID")} 
                                                    label={text("Company")} />
                                            </Form.Group>
                                            <Form.Group widths="equal"  >
                                                <Form.Field
                                                    required
                                                    error={errors.PaymentArrangementID}
                                                    name='PaymentArrangementID'
                                                    value={reservation.PaymentArrangementID}
                                                    control={PaymentArrangementsDropDown}
                                                    filter={filterPaymentArrangement}
                                                    onChange={(value) => onChangeReservationField(value, "PaymentArrangementID")}
                                                    label={text("PaymentArrangement")}></Form.Field>

                                                <Form.Input name='VoucherNumber' label={text('VoucherNumber')}
                                                    placeholder={text('VoucherNumber')}
                                                    maxLength="50"
                                                    value={reservation.VoucherNumber || ""}
                                                    onChange={(e, { value, name }) => onChangeReservationField(value, name)} />
                                            </Form.Group>
                                        </Form>
                                    </Panel>
                                </Grid.Column>

                                <GridColumn>
                                    <Panel header={text('DefaultGuestValues')}>
                                        <Form>
                                            <Form.Group widths="equal"  >
                                                <Form.Field
                                                    required
                                                    error={errors.NationalityID}
                                                    value={guest.NationalityID || defaultGuestNationalityID}
                                                    control={NationalitiesDropDown}
                                                    onChangeItem={onChangeNationalityField}
                                                    label={text('Nationality')} />
                                                <Form.Field
                                                    value={guest.LanguageID}
                                                    control={LanguagesDropDown}
                                                    onChange={(value) => onChangeGuestField(value, "LanguageID")}
                                                    label={text('Language')}/>
                                            </Form.Group>
                                            <Form.Group widths="equal">
                                                {Categories.length ?
                                                    <Form.Field
                                                        multiple
                                                        value={reservation.ReservationInCategories || []}
                                                        control={ReservationCategoriesDropDown}
                                                        data={Categories}
                                                        onChange={(value) => onChangeReservationCategories(value)}
                                                        label={text('ReservationCategories')}
                                                    />
                                                    : ''}
                                                <Form.Field />
                                            </Form.Group>
                                        </Form>
                                    </Panel>
                                </GridColumn>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column >
                                    <Panel header={text('Contact')}>
                                        <Form>
                                            <Form.Group widths="equal" >
                                                <Form.Input
                                                    required
                                                    error={errors.GuestLastName}
                                                    name='LastName' label={text('LastName')}
                                                    placeholder={text('LastName')}
                                                    value={guest.LastName || ""}
                                                    onChange={(e, { value, name }) => onChangeGuestField(value, name)} />

                                                <Form.Input required
                                                    error={errors.GuestFirstName}
                                                    name='FirstName' label={text('FirstName')}
                                                    placeholder={text('FirstName')}
                                                    value={guest.FirstName || ""}
                                                    onChange={(e, { value, name }) => onChangeGuestField(value, name)} />
                                            </Form.Group >
                                            <Form.Group widths='equal'>
                                                <Form.Input name='Email' label={text('Email')} placeholder={text('Email')} type="email" value={guest.Email || ''} onChange={(e, { value, name }) => onChangeGuestField(value, name)} />
                                                <Form.Input name='Phone' label={text('Phone')} placeholder={text('Phone')} value={guest.Phone || ''} onChange={(e, { value, name }) => onChangeGuestField(value, name)} />
                                            </Form.Group >
                                        </Form>
                                    </Panel>
                                </Grid.Column>
                                <Grid.Column style={{ zIndex: 1 }}>
                                    <Panel header={text("Comments")} >
                                        <CommentsEditor/>
                                    </Panel>
                                </Grid.Column>
                            </Grid.Row>


                        </Grid>
                    </Grid.Column>
                    <Grid.Column width="5">
                        <MethodOfPayment reservation={reservation}></MethodOfPayment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>



        </React.Fragment>
    )
}
export default GeneralTab